import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function OrganizerPaymentReturn() {
  const [params] = useSearchParams();
  const raceId = params.get("race_id");
  const ref = params.get("ref") || "";
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        const { data } = await api.post(`/payments/confirm?race_id=${raceId}${ref ? `&ref=${ref}` : ""}`);
        const paid = data.paid || data.payment_status === "paid";
        const feat = data.featured;
        if (paid && feat) { setStatus("paid"); toast.success("Payment received — listing submitted & featured activated"); }
        else if (feat && !paid) { setStatus("featured"); toast.success("Featured placement activated"); }
        else if (paid) { setStatus("paid"); toast.success("Payment received & race submitted for approval"); }
        else { setStatus("pending"); }
        setTimeout(() => nav("/organizer", { replace: true }), paid || feat ? 1800 : 2500);
      } catch { setStatus("error"); setTimeout(() => nav("/organizer", { replace: true }), 2500); }
    })();
  }, [raceId, ref, nav]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0a1420] text-white">
      <div className="text-center max-w-sm px-6">
        {status === "checking" && <><Loader2 className="animate-spin text-[#22d3ee] mx-auto" size={40} /><p className="mt-4">Confirming your payment…</p></>}
        {status === "paid" && <><CheckCircle2 className="text-emerald-400 mx-auto" size={48} /><h1 className="font-display font-black uppercase text-2xl mt-3">Payment Successful</h1><p className="text-slate-300 mt-1">Your race has been submitted for approval. Redirecting…</p></>}
        {status === "featured" && <><CheckCircle2 className="text-emerald-400 mx-auto" size={48} /><h1 className="font-display font-black uppercase text-2xl mt-3">Featured Activated</h1><p className="text-slate-300 mt-1">Your race is now featured. Redirecting…</p></>}
        {status === "pending" && <p>Payment is pending. Redirecting to your dashboard…</p>}
        {status === "error" && <p>We couldn't confirm the payment. Redirecting…</p>}
      </div>
    </div>
  );
}
